import "../DrugTable/DrugTable.css";

export default function IndividualDrugConfirm({ drugData }) {
  return (
    <div className="table-container">
      <h2 className="table-heading">
        Individual Drug Assignment Update Inventory
      </h2>
      <table className="drug-table">
        <thead>
          <tr>
            <th>Drug Name</th>
            <th>Sequence Range</th>
            <th>Depot Name</th>
            <th>Lot Number</th>
            <th>Label Group</th>
            <th>Kit Quantity</th>
            <th>Performed By</th>
            <th>Protocol</th>
          </tr>
        </thead>
        <tbody>
          {drugData.map((row, idx) => (
            <tr key={idx} className={"approved-row"}>
              <td>{row.drugName}</td>
              <td>{row.sequenceRange}</td>
              <td>{row.depotName}</td>
              <td>{row.lotNumber}</td>
              <td>{row.labelGroupName}</td>
              <td>{row.kitQuantity}</td>
              <td>{!row.performedBy ? "N/A" : row?.performedBy}</td>
              <td>{row.protocol}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
